/* =====================================================================
   LATAKAN - contact-page.js  (page Contact : "Contactez-nous")
   Charge APRES core.js. Gere : FAQ accordeon, repli du formulaire sur
   mobile, validation + etat de succes, pastille Favoris de la tab bar,
   bouton Compte (toast). S'appuie sur window.LatakanCore / LatakanWish.
   ===================================================================== */
(function () {
  'use strict';
  var core = window.LatakanCore || {};
  var $ = core.$ || function (s, r) { return (r || document).querySelector(s); };
  var $$ = core.$$ || function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var toast = core.toast || function () {};

  /* ----------------------------- FAQ accordeon ----------------------- */
  $$('.ctfaq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var it = btn.closest('.ctfaq__it');
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (it) it.classList.toggle('is-open', !open);
    });
  });

  /* ----------------------------- repli formulaire (mobile) ----------- */
  var form = $('#ctForm');
  var toggle = $('#ctFormToggle');
  var MQ = window.matchMedia ? window.matchMedia('(max-width:860px)') : { matches: false, addListener: function () {} };
  if (toggle && form) {
    toggle.addEventListener('click', function () {
      if (!MQ.matches) return; // repli actif uniquement sur mobile
      var collapsed = form.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
    var syncMode = function () {
      if (!MQ.matches) { form.classList.remove('is-collapsed'); toggle.setAttribute('aria-expanded', 'true'); }
    };
    if (MQ.addEventListener) MQ.addEventListener('change', syncMode);
    else if (MQ.addListener) MQ.addListener(syncMode);
    syncMode();
  }

  /* ----------------------------- select placeholder ------------------ */
  var subject = $('#ctSubject');
  if (subject) {
    subject.addEventListener('change', function () {
      subject.classList.toggle('is-placeholder', subject.value === '');
    });
  }

  /* ----------------------------- validation + envoi ------------------ */
  var body = $('#ctFormBody');
  function fieldError(input, on) {
    if (!input) return;
    input.style.borderColor = on ? '#E8424E' : '';
    input.style.boxShadow = on ? '0 0 0 4px rgba(232,66,78,.12)' : '';
  }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  if (body) {
    // reset visuel des erreurs a la saisie
    body.addEventListener('input', function (e) {
      if (e.target.matches('.ctinput,.cttextarea,.ctselect')) fieldError(e.target, false);
    });

    body.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = $('#ctName'), email = $('#ctEmail'), message = $('#ctMessage');
      var bad = false, firstBad = null;

      if (subject && subject.value === '') { subject.classList.add('is-placeholder'); fieldError(subject, true); bad = true; firstBad = firstBad || subject; }
      if (name && !name.value.trim()) { fieldError(name, true); bad = true; firstBad = firstBad || name; }
      if (email && !emailOk(email.value.trim())) { fieldError(email, true); bad = true; firstBad = firstBad || email; }
      if (message && !message.value.trim()) { fieldError(message, true); bad = true; firstBad = firstBad || message; }

      if (bad) {
        if (firstBad) firstBad.focus();
        toast('Champs manquants', 'Vérifiez les informations en rouge.', 'Oups');
        return;
      }

      // succes : on remplace le corps du formulaire par un message de confirmation
      var firstName = (name.value.trim().split(/\s+/)[0]) || '';
      var success = document.createElement('div');
      success.className = 'ctsuccess';
      success.setAttribute('role', 'status');
      success.innerHTML =
        '<span class="ctsuccess__ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg></span>' +
        '<h3>Message bien reçu' + (firstName ? ', ' + firstName : '') + ' !</h3>' +
        '<p>Merci de nous avoir écrit. Notre équipe vous répond par email sous 24h ouvrées.</p>' +
        '<button class="ctsuccess__btn" type="button" id="ctNewMsg">Envoyer un autre message</button>';

      body.replaceWith(success);
      toast('Message envoyé', 'Réponse sous 24h ouvrées.', 'Merci !');

      var again = $('#ctNewMsg');
      if (again) again.addEventListener('click', function () { window.location.reload(); });
    });
  }

  /* ----------------------------- pastille Favoris (tab bar) ----------- */
  var favBadge = $('#ctTabFav');
  function syncFav() {
    if (!favBadge || !window.LatakanWish) return;
    var n = window.LatakanWish.count();
    favBadge.textContent = n > 99 ? '99+' : n;
    favBadge.hidden = n === 0;
  }
  if (window.LatakanWish && window.LatakanWish.subscribe) window.LatakanWish.subscribe(syncFav);
  syncFav();

  /* ----------------------------- bouton Compte ----------------------- */
  var acct = $('#acctBtn');
  if (acct) acct.addEventListener('click', function () {
    toast('Espace client', 'Bientôt disponible sur Latakan.', 'À venir');
  });
})();
